import { Typography } from '@mui/material'
import { FC, ReactElement } from 'react'
import { FormattedMessage, IntlShape } from 'react-intl'

interface FieldLabelProps {
    name: string
    required?: boolean
}

export const FieldLabel: FC<FieldLabelProps> = ({ name, required }): ReactElement => (
    <>
        {name}
        {' '}
        {!required && (
            <Typography
                component="span"
                variant="caption"
                color="text.secondary"
            >
                (
                <FormattedMessage id="dynamic_form_optional" defaultMessage="optional" />
                )
            </Typography>
        )}
    </>
)

export function fieldLabelString(name: string, required: boolean | undefined, intl: IntlShape): string {
    if (required) return name
    return intl.formatMessage(
        { id: 'dynamic_form_field_optional', defaultMessage: '{field} (optional)' },
        { field: name },
    )
}
